export { default as ConfigPlataforma } from './ConfigForm';
